import { registerMockAPI } from '~/mocks/mockApis';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetShippersDeliveryOperationsResponse } from '~/types/delivery-agency.types';

const useGetShippersDeliveryOperations = () => {
  const { runAsync } = useAsyncHandler();

  const getShippersDeliveryOperations = useAPI<unknown, TypeGetShippersDeliveryOperationsResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPERS_DELIVERY_OPERATIONS,
    method: 'get',
  });

  const requestDeliveryOperations = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: TypeGetShippersDeliveryOperationsResponse['data']) => void;
    onError?: (error: TypeErrorResponseData['error']) => void;
  }) => {
    runAsync(() => getShippersDeliveryOperations({}), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestDeliveryOperations };
};

export default useGetShippersDeliveryOperations;

registerMockAPI<TypeGetShippersDeliveryOperationsResponse>({
  method: 'get',
  endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPERS_DELIVERY_OPERATIONS,
  label: '화주사정보/화주사정보/배송운영정보',
  scenarios: [
    {
      name: '정상 응답 — 입고Hub 3곳',
      response: {
        data: {
          inboundHubs: [
            {
              code: 'HUB_GIMPO',
              description: '김포 Hub',
              inboundSchedules: [
                { from: '09:00', to: '12:00' },
                { from: '14:00', to: '18:00' },
              ],
            },
            { code: 'HUB_PYEONGTAEK', description: '평택 Hub', inboundSchedules: [{ from: '10:00', to: '16:00' }] },
            { code: 'HUB_CHANGWON', description: '창원 Hub', inboundSchedules: [] },
          ],
        },
      },
    },
  ],
});
